import { Navigate, useLocation, useParams } from 'react-router'
import { ServicePage as ServicePageTemplate } from '../components/service/ServicePage'
import {
  findServicePageContent,
  serviceCategories,
  servicePages,
  type ServicePageContentModel,
} from '../data'
import { NotFoundPage } from './NotFoundPage'

function createScaffoldContent(categorySlug?: string, serviceSlug?: string): ServicePageContentModel | null {
  const category = serviceCategories.find(({ slug }) => slug === categorySlug)
  const service = servicePages.find(
    ({ categoryId, slug }) => category?.id === categoryId && slug === serviceSlug,
  )

  if (!category || !service) return null

  return {
    serviceId: service.id,
    enabled: service.enabled,
    canonicalPath: `/services/${category.slug}/${service.slug}`,
    aliases: [],
    pageName: service.name,
    parentCategory: category.id,
    parentCategoryLabel: category.name,
    parentCategoryPath: `/services/${category.slug}`,
    hero: {
      imageSrc: '/images/store-services-hero.png',
      imageAlt: 'Pack Print Mail service counter',
    },
    heading: `${service.name} in Waxahachie, TX`,
    subheading: service.shortDescription,
    seo: {
      title: `${service.name} | Waxahachie, TX | Pack Print Mail`,
      description: service.shortDescription,
    },
    sections: [
      {
        paragraphs: [
          'Detailed service information is being prepared. Call Pack Print Mail for current availability and help from our local team.',
        ],
      },
    ],
    question: {
      heading: `Have A Question About ${service.name}?`,
      body: 'Call for current service details or send us a message and our team will be glad to help.',
    },
  }
}

export function ServicePage() {
  const location = useLocation()
  const { categorySlug, serviceSlug } = useParams()
  const configuredPage = findServicePageContent(location.pathname)
  const page = configuredPage ?? createScaffoldContent(categorySlug, serviceSlug)

  if (!page) return <NotFoundPage />
  if (!page.enabled) return <NotFoundPage />

  if (configuredPage && location.pathname !== configuredPage.canonicalPath) {
    return (
      <Navigate
        replace
        to={{
          pathname: configuredPage.canonicalPath,
          search: location.search,
          hash: location.hash,
        }}
      />
    )
  }

  return <ServicePageTemplate page={page} />
}
